import app from 'flarum/forum/app';
import bestAnswer from './bestAnswer';
import bookmarks from './bookmarks';
import deckHero from './deckHero';
import downloads from './downloads';
import drawerDropdowns from './drawerDropdowns';
import discussionBadges from './discussionBadges';
import discussionViews from './discussionViews';
import exposeThemeVars from './exposeThemeVars';
import followingHero from './followingHero';
import followTags from './followTags';
import leaderboardPage from './leaderboardPage';
import limitSidebarTags from './limitSidebarTags';
import masquerade from './masquerade';
import reactions, { likesAsReaction } from './reactions';
import seasons from './seasons';
import shareSocial from './shareSocial';
import tableButton from './tableButton';
import tagsPage from './tagsPage';
import twoFactor from './twoFactor';
import userDirectory from './userDirectory';
export { default as extend } from './extend';
app.initializers.add('bimmerdock-theme', () => {
  // Initializers run before app.forum is loaded.
  app.beforeMount(exposeThemeVars);
  seasons();
  discussionBadges();
  downloads();
  drawerDropdowns();
  if ('flarum-tags' in flarum.extensions) {
    limitSidebarTags();
    tagsPage();
  }
  if ('flarum-markdown' in flarum.extensions) {
    tableButton();
  }
  if ('flarum-deck' in flarum.extensions) {
    deckHero();
  }
  if ('fof-best-answer' in flarum.extensions) {
    bestAnswer();
  }
  if ('huseyinfiliz-leaderboard' in flarum.extensions) {
    leaderboardPage();
  }
  if ('fof-user-directory' in flarum.extensions) {
    userDirectory();
  }
  if ('fof-share-social' in flarum.extensions) {
    shareSocial();
  }
  if ('fof-masquerade' in flarum.extensions) {
    masquerade();
  }
  if ('fof-bookmarks' in flarum.extensions) {
    bookmarks();
  }
  if ('fof-reactions' in flarum.extensions) {
    reactions();
  }
  if ('fof-discussion-views' in flarum.extensions) {
    discussionViews();
  }
  if ('ianm-twofactor' in flarum.extensions) {
    twoFactor();
  }
});

// fof/follow-tags initialises late (priority -1) and extends the same index
// page hero, sidebar and toolbar; these change what it adds, so they run
// after it. Likewise the likes shown as a reaction change what flarum/likes
// adds to posts.
app.initializers.add('bimmerdock-theme-late', () => {
  if ('flarum-subscriptions' in flarum.extensions) {
    followingHero();
  }
  if ('fof-follow-tags' in flarum.extensions) {
    followTags();
  }
  if ('fof-reactions' in flarum.extensions) {
    likesAsReaction();
  }
}, -10);